import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/napster': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M298.3 373.6C284.1 387.2 267 397.7 247.9 404.1 228.9 397.7 211.7 387.2 197.6 373.6H298.3zM342.3 174C362.3 157.1 385.9 144.8 411.9 137.8V299C411.9 518.4 83.9 516.6 83.9 299.3V137.7C109.8 144.6 133.5 157.3 153.4 174.1 210.2 134.1 285.9 134.2 342.3 174zM133.5 115.5C197.9 55.5 297.8 55.4 362.4 115.3 355.3 118.8 348.5 122.6 341.8 126.8 283.1 96.3 212.6 96.4 153.9 126.9 147.6 122.9 140 118.7 133.5 115.5zM43.8 93.2V162.5C-14.6 199-14.6 283.6 43.9 320.8 70.3 565.9 425.6 561.1 451.5 322.3L451.8 320.6C510.5 284.3 510.7 198.9 452 162.4V93.2C434.7 93.7 418 96.2 401.9 100.6 319.9 9.1 176.4 9.1 94.4 100.7 78.1 96.3 61.3 93.7 43.8 93.2zM259.2 352S295.2 351.7 320.5 350.5C330.7 350 341.6 346.5 346 344 372.3 328.9 371.4 304.8 372.2 296.6 292.7 296 272.3 292.7 259.2 352zM123.7 296.7C124.5 304.9 123.6 329 149.9 344.1 154.3 346.6 165.1 350.1 175.4 350.6 200.7 351.7 236.7 352.1 236.7 352.1 223.5 292.7 203 296 123.7 296.7zM292.8 420.1C289.6 414.8 285.9 412.8 285.9 412.8 261.1 420.1 233.7 419.7 210 412.8 210 412.8 207.1 414.3 203.6 419.4 200.8 423.5 199.9 429 199.9 429 229 446.6 267 446.6 296.1 429 296 428.9 295.8 425 292.8 420.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/napster.js
// module id = +VbA
// module chunks = 144